import { axios } from "./config.js";
import type {
	TAuthVerifyCreate,
	TAuthVerifyResend,
	TAxiosGenRes,
	TBasicType,
	TForgotPass,
	TLoginParam,
	TLoginRes,
	TResetPass,
} from "./types";

export default {
	// Auth
	authRegister: (params: any) =>
		axios.post<TAxiosGenRes<TBasicType>>("auth/register", params),
	authRenewSession: () =>
		axios.post<{ data: { data: string } }>("auth/renew-session"),
	authLogout: () => axios.get("auth/logout", { validateStatus: null }),
	authVerifyCreate: (params: TAuthVerifyCreate) =>
		axios.post<TLoginRes>("auth/verify", params),
	authVerifyResend: (params: TAuthVerifyResend) =>
		axios.put("auth/verify", params),
	authForgot: (params: TForgotPass) =>
		axios.post("auth/forgot-password", params),
	authResetPass: (params: TResetPass) =>
		axios.put("auth/forgot-password", params),
	// DaiDai - Auth
	authLogin: (params: TLoginParam) =>
		axios.post<TLoginRes>("auth/login", params),
	authCheckJwt: () => axios.get("auth/check-jwt"),
};
